import { pickActiveEvmWallet, connectEvmWallet } from './detectEvmWallets';
import { EVM_WALLET_SIGN_MSG, evmWalletMismatchMsg } from './evmWalletMessages';
import { formatHlDepositError } from './hlDepositMessages';
import { signHlUserSignedAction, formatHlSignNetworkError } from './hlSignNetwork';

const APPROVE_AGENT_TYPES = {
  'HyperliquidTransaction:ApproveAgent': [
    { name: 'hyperliquidChain', type: 'string' },
    { name: 'agentAddress', type: 'address' },
    { name: 'agentName', type: 'string' },
    { name: 'nonce', type: 'uint64' },
  ],
};

const APPROVE_BUILDER_FEE_TYPES = {
  'HyperliquidTransaction:ApproveBuilderFee': [
    { name: 'hyperliquidChain', type: 'string' },
    { name: 'maxFeeRate', type: 'string' },
    { name: 'builder', type: 'address' },
    { name: 'nonce', type: 'uint64' },
  ],
};

async function connectMatchingWallet(walletAddress) {
  const w = await pickActiveEvmWallet();
  if (!w) throw new Error(EVM_WALLET_SIGN_MSG);

  const { address } = await connectEvmWallet(w.provider);
  if (
    walletAddress &&
    address.toLowerCase() !== String(walletAddress).trim().toLowerCase()
  ) {
    throw new Error(
      evmWalletMismatchMsg(address, `your linked HL wallet (${walletAddress.slice(0, 6)}…${walletAddress.slice(-4)})`)
    );
  }

  return { address, provider: w.provider };
}

async function prepareSignConfirm({ apiBase, authHeaders, prepareUrl, confirmUrl, walletAddress, types }) {
  const axios = (await import('axios')).default;
  try {
    const { address, provider } = await connectMatchingWallet(walletAddress);

    const { data: prepared } = await axios.post(prepareUrl, {}, { headers: authHeaders() });

    const signature = await signHlUserSignedAction({
      provider,
      fromAddress: address,
      action: prepared.action,
      types,
    });

    const { data: confirmed } = await axios.post(
      confirmUrl,
      { action: prepared.action, nonce: prepared.nonce, signature },
      { headers: authHeaders() }
    );

    return { ...prepared, ...confirmed };
  } catch (e) {
    const apiRaw = e.response?.data?.error;
    const msg = apiRaw || formatHlSignNetworkError(e) || e.message || String(e);
    throw new Error(formatHlDepositError(msg, walletAddress) || msg);
  }
}

export async function approveAgentWithBrowserWallet({
  apiBase,
  authHeaders,
  walletId,
  walletAddress,
  apiPrefix = 'multi-asset',
}) {
  return prepareSignConfirm({
    apiBase,
    authHeaders,
    walletAddress,
    prepareUrl: `${apiBase}/${apiPrefix}/wallets/${walletId}/agent/prepare`,
    confirmUrl: `${apiBase}/${apiPrefix}/wallets/${walletId}/agent/confirm`,
    types: APPROVE_AGENT_TYPES,
  });
}

export async function approveBuilderFeeWithBrowserWallet({ apiBase, authHeaders, walletId, walletAddress }) {
  return prepareSignConfirm({
    apiBase,
    authHeaders,
    walletAddress,
    prepareUrl: `${apiBase}/multi-asset/wallets/${walletId}/builder-fee/prepare`,
    confirmUrl: `${apiBase}/multi-asset/wallets/${walletId}/builder-fee/confirm`,
    types: APPROVE_BUILDER_FEE_TYPES,
  });
}
